var hostname = window.location.hostname;
var isLocal = /^(?:localhost|(?:\d{1,3}\.){3}\d{1,3}|::1|\[::1\])$/i.test(hostname);

// Load adrum in both standalone and Polaris shell modes.
// Only skip on localhost/IP/IPv6 loopback for local development.
if (!isLocal) {
    var PROD_KEY = 'AD-AAB-ABE-BVH';
    var TEST_KEY = 'AD-AAB-ABA-SBC';

    try {
        window['adrum-start-time'] = new Date().getTime();

        // In production (standalone or Polaris shell), assets live at /my-profile/assets/.
        var appContextPath = '/my-profile/';
        var origin = window.location.origin;

        // adrum.js is fetched from the current page origin so the Polaris single-bundle
        // fetch interceptor can serve it from the embedded assets (the shell origin does
        // not host these files on disk).
        var adrumScriptUrl = origin + appContextPath + 'assets/adrum/adrum.js';

        // adrum.js loads adrum-ext.<hash>.js itself via a <script src> tag, which BYPASSES
        // the single-bundle fetch/XHR interceptors. Inside the Polaris shell,
        // window.location.origin is the SHELL origin, which does not serve
        // /my-profile/assets, so the ext agent would 404. window['__mfeAssetBase'] is set
        // by the single bundle to the MFE's real deploy origin; use it for the ext base
        // (script src loads cross-origin fine) and fall back to the page origin for
        // standalone dotcom, where the page origin already hosts the MFE assets.
        var mfeAssetBase = window['__mfeAssetBase'] || (origin + '/my-profile');
        var adrumExtUrl = mfeAssetBase + '/assets/adrum';

        // Fallback URL for adrum.js: if the fetch interceptor is unavailable or the
        // fetch is blocked, we load via a native <script src>, which BYPASSES the
        // interceptor. That request must go to the MFE origin (__mfeAssetBase), not the
        // shell origin, otherwise it 404s in Polaris - the very scenario the fallback
        // exists for. In standalone dotcom mfeAssetBase collapses to the page origin, so
        // this stays correct there too.
        var adrumScriptFallbackUrl = adrumExtUrl + '/adrum.js';

        // Copy nonce from an existing script tag for CSP compliance
        var currentNonce = '';
        var existingScript = document.querySelector('script[nonce]');
        if (existingScript) {
            currentNonce = existingScript.nonce || existingScript.getAttribute('nonce') || '';
        }

        (function (config) {
            config.appKey = (/^www\.fedex\.com$/i).test(hostname) ? PROD_KEY : TEST_KEY;
            config.adrumExtUrlHttps = adrumExtUrl;
            config.adrumExtUrlHttp = adrumExtUrl;
            config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
            config.isZonePromise = true;
            config.xd = { enable: false };
            config.spa = { 'spa2': true };
        })(window['adrum-config'] || (window['adrum-config'] = {}));

        // Use fetch() to load adrum.js so the single-bundle asset interceptor
        // can serve it from embedded assets when running inside Polaris shell.
        fetch(adrumScriptUrl)
            .then(function (res) {
                if (!res.ok) { throw new Error('adrum.js fetch failed: ' + res.status); }
                return res.text();
            })
            .then(function (scriptText) {
                var adrumScript = document.createElement('script');
                if (currentNonce) { adrumScript.setAttribute('nonce', currentNonce); }
                adrumScript.textContent = scriptText;
                document.head.appendChild(adrumScript);
            })
            .catch(function () {
                // Fallback: load via script src if fetch fails or is blocked.
                // Use the MFE origin (adrumScriptFallbackUrl) so it resolves in Polaris.
                var adrumScript = document.createElement('script');
                if (currentNonce) { adrumScript.setAttribute('nonce', currentNonce); }
                adrumScript.src = adrumScriptFallbackUrl;
                document.head.appendChild(adrumScript);
            });
    } catch (error) {
        (console.error || console.log).call(console, error.stack || error);
    }
}
